<template>
  <div class="payment-records">
    <el-card class="box-card">
      <!-- 搜索栏 -->
      <div class="filter-container">
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="订单编号">
            <el-input
              v-model="queryParams.order_id"
              placeholder="请输入订单编号"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item label="供应商">
            <el-input
              v-model="queryParams.supplier_id"
              placeholder="请输入供应商"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据表格 -->
      <el-table
        v-loading="loading"
        :data="recordList"
        border
        style="width: 100%"
      >
        <!-- <el-table-column prop="order_id" label="订单编号" width="180" show-overflow-tooltip /> -->
        <el-table-column prop="supplier_name" label="供应商" width="120" align="center" />
        <el-table-column prop="payment_amount" label="付款金额" width="120" align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.payment_amount }}
          </template>
        </el-table-column>

        <el-table-column prop="payable_amount" label="应付金额" width="120" align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.payable_amount }}
          </template>
        </el-table-column>
        <el-table-column prop="Order_generation_time" label="订单生成时间" width="160" align="center" />
        <el-table-column prop="payment_generation_time" label="付款生成时间" width="160" align="center" />
        <el-table-column prop="payment_time" label="付款时间" width="160" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.payment_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="payment_person" label="付款人" width="120" align="center" />
        <el-table-column prop="receiver_name" label="收款人" width="120" align="center" />
        <el-table-column prop="receiver_bank" label="收款银行" width="150" align="center" />
        <el-table-column prop="receiver_account" label="收款账号" width="150" show-overflow-tooltip align="center" />
        <el-table-column prop="pay_remark" label="付款备注" show-overflow-tooltip align="center" />
        <el-table-column prop="application.status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.application.status)">
              {{ getStatusText(scope.row.application.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-dropdown @command="(command) => handleCommand(command, scope.row)">
              <span class="el-dropdown-link">
                <el-button type="text" size="mini">
                  处理<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  command="update"
                  v-hasPermi="['finance:payment:edit']"
                  icon="el-icon-edit"
                >修改</el-dropdown-item>
                <el-dropdown-item
                  command="delete"
                  v-hasPermi="['finance:payment:delete']"
                  icon="el-icon-delete"
                  class="dropdown-danger"
                >删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>

      <!-- 修改对话框 -->
      <el-dialog
        title="修改付款记录"
        :visible.sync="updateDialogVisible"
        width="700px"
        append-to-body
      >
        <el-form ref="updateForm" :model="updateForm" :rules="formRules" label-width="100px">
          <el-row :gutter="20">
            <!-- 左侧付款信息 -->
            <el-col :span="12">
              <div class="form-section-title">付款信息</div>
              <el-form-item label="付款类型" prop="payment_type">
                <el-select v-model="updateForm.payment_type" placeholder="请选择付款类型" style="width: 100%">
                  <el-option
                    v-for="item in paymentTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              
              <el-form-item label="付款金额" prop="payment_amount">
                <el-input-number 
                  v-model="updateForm.payment_amount"
                  :precision="2"
                  :min="0"
                  controls-position="right"
                  style="width: 100%"
                />
              </el-form-item>
              
              <el-form-item label="付款时间" prop="payment_time">
                <el-date-picker
                  v-model="updateForm.payment_time"
                  type="datetime"
                  placeholder="选择付款时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                />
              </el-form-item>
              
              <el-form-item label="付款凭证" prop="payment_image">
                <el-upload
                  class="upload-container"
                  action="/api/api/v1/upload/file"
                  :headers="uploadHeaders"
                  :on-success="handleUploadSuccess"
                  :on-error="handleUploadError"
                  :before-upload="beforeUpload"
                  :on-exceed="handleExceed"
                  :limit="1"
                  :file-list="updateForm.fileList"
                  name="file"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
                </el-upload>
              </el-form-item>
              
              <el-form-item label="付款人" prop="payment_person">
                <el-input v-model="updateForm.payment_person" placeholder="请输入付款人" />
              </el-form-item>
              
              <el-form-item label="付款渠道" prop="pay_channel">
                <el-select 
                  v-model="updateForm.pay_channel" 
                  placeholder="请选择付款渠道" 
                  style="width: 100%" 
                  @change="() => getPayAccountDict(false)"
                >
                  <el-option
                    v-for="item in payChannelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              
              <el-form-item label="付款账号" prop="pay_account">
                <el-select v-model="updateForm.pay_account" placeholder="请选择付款账号" style="width: 100%">
                  <el-option
                    v-for="item in payAccountOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              
              <el-form-item label="付款备注" prop="pay_remark">
                <el-input
                  type="textarea"
                  v-model="updateForm.pay_remark"
                  placeholder="请输入付款备注"
                />
              </el-form-item>
            </el-col>

            <!-- 右侧收款信息 -->
            <el-col :span="12">
              <div class="form-section-title">收款信息</div>
              <el-form-item label="收款方式" prop="receiver_method">
                <el-select v-model="updateForm.receiver_method" placeholder="请选择收款方式" style="width: 100%">
                  <el-option
                    v-for="item in paymentMethodOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              
              <el-form-item label="收款渠道" prop="receiver_channel">
                <el-select v-model="updateForm.receiver_channel" placeholder="请选择收款渠道" style="width: 100%">
                  <el-option
                    v-for="item in paymentChannelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              
              <el-form-item label="收款人" prop="receiver_name">
                <el-input v-model="updateForm.receiver_name" placeholder="请输入收款人" />
              </el-form-item>
              
              <el-form-item label="收款银行" prop="receiver_bank">
                <el-input v-model="updateForm.receiver_bank" placeholder="请输入收款银行" />
              </el-form-item>
              
              <el-form-item label="收款账号" prop="receiver_account">
                <el-input v-model="updateForm.receiver_account" placeholder="请输入收款账号" />
              </el-form-item>
              
              <el-form-item label="银行行号" prop="receiver_bank_code">
                <el-input v-model="updateForm.receiver_bank_code" placeholder="请输入银行行号" />
              </el-form-item>
              
              <el-form-item label="收款备注" prop="receiver_remark">
                <el-input
                  type="textarea"
                  v-model="updateForm.receiver_remark"
                  placeholder="请输入收款备注"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelUpdate">取 消</el-button>
          <el-button type="primary" @click="submitUpdate">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'PaymentRecords',
  data() {
    return {
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 付款记录列表
      recordList: [],
      // 查询参数
      queryParams: {
        page: 1,
        page_size: 10,
        supplier_id: '',
        order_id: ''
      },
      // 修改对话框显示状态
      updateDialogVisible: false,
      // 修改表单对象
      updateForm: {
        id: undefined,
        payment_amount: 0,
        receiver_name: '',
        receiver_bank: '',
        receiver_account: '',
        pay_remark: '',
        payment_image: '',
        fileList: [],
      },
      // 表单校验规则
      formRules: {
        payment_amount: [
          { required: true, message: '请输入付款金额', trigger: 'blur' }
        ],
        payment_time: [
          { required: true, message: '请选择付款时间', trigger: 'change' }
        ],
        payment_person: [
          { required: true, message: '请输入付款人', trigger: 'blur' }
        ],
        receiver_name: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ],
        receiver_bank: [
          { required: true, message: '请输入收款银行', trigger: 'blur' }
        ],
        receiver_account: [
          { required: true, message: '请输入收款账号', trigger: 'blur' }
        ]
      },
      paymentMethodOptions: [], // 收款方式选项
      paymentChannelOptions: [], // 收款渠道选项
      paymentTypeList: [], // 付款类型选项
      payChannelOptions: [], // 付款渠道选项
      payAccountOptions: [], // 付款账号选项
      channels: [], // 渠道数据
      uploadHeaders: {
        Authorization: 'Bearer ' + this.$store.getters.token
      },
    }
  },
  created() {
    this.getList()
    
    // 加载字典数据
    Promise.all([
      this.getPaymentMethodDict(),
      this.getPaymentChannelDict(),
      this.getPaymentTypeDict(),
      this.getPayChannelDict()
    ]).catch(error => {
      console.error('加载字典数据失败:', error)
      this.$message.error('加载字典数据失败')
    })
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true
      try {
        const response = await request({
          url: '/api/v1/purchasing-order/payment/record/list',
          method: 'post',
          data: this.queryParams
        })
        
        if (response.status === 1) {
          this.recordList = response.data || []
          this.total = response.total || 0
        } else {
          this.$message.error(response.msg || '获取付款记录失败')
        }
      } catch (error) {
        console.error('获取付款记录失败:', error)
        this.$message.error('获取付款记录失败')
      } finally {
        this.loading = false
      }
    },
    
    // 搜索按钮操作
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        page: 1,
        page_size: 10,
        supplier_id: '',
        order_id: ''
      }
      this.getList()
    },
    
    // 每页显示条数改变
    handleSizeChange(val) {
      this.queryParams.page_size = val
      this.getList()
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getList()
    },

    // 格式化日期时间
    formatDateTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
    },

    // 获取状态类型
    getStatusType(status) {
      const statusMap = {
        1: 'info',    // 待审核
        2: 'warning', // 审核中
        3: 'success', // 已通过
        4: 'danger',  // 已驳回
        7: 'success'  // 已完成
      }
      return statusMap[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        1: '待审核',
        2: '审核中',
        3: '已通过',
        4: '已驳回',
        7: '已完成'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取收款方式字典
    async getPaymentMethodDict() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'GYSSKFS',
            dictItemName: ''
          }
        })
        if (res.status === 1 && res.data) {
          this.paymentMethodOptions = res.data.map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取收款类型失败:', error)
        this.$message.error('获取收款类型失败')
      }
    },
    //获取收款渠道字典
    async getPaymentChannelDict() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'GYSSKQD',
            dictItemName: ''
          }
        })
        if (res.status === 1 && res.data) {
          this.paymentChannelOptions = res.data.map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取收款渠道失败:', error)
        this.$message.error('获取收款渠道失败')
      }
    },

    // 获取付款类型字典
    async getPaymentTypeDict() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'FKLX',
            dictItemName: ''
          }
        })
        if (res.status === 1 && res.data) {
          this.paymentTypeList = res.data.map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取付款类型失败:', error)
        this.$message.error('获取付款类型失败')
      }
    },

    // 获取付款渠道字典
    async getPayChannelDict() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'FKQD',
            dictItemName: ''
          }
        })
        if (res.status === 1 && res.data) {
          this.channels = res.data // 付款渠道  
          //这里只取一级渠道   
          this.payChannelOptions = res.data.filter(item => item.parentId === "0").map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取付款渠道失败:', error)
        this.$message.error('获取付款渠道失败')
      }
    },

    // 获取付款账号字典
    getPayAccountDict(isInitial = false) {  // 添加一个参数来判断是否是初始加载
      // 找到选中的渠道
      const channel = this.channels.find(item => item.itemValue === this.updateForm.pay_channel)
      
      if (channel) {
        // 获取该渠道下的所有子账号
        this.payAccountOptions = this.channels
          .filter(item => item.parentId === channel.itemId)
          .map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        
        // 只有在手动切换渠道时才清空付款账号
        if (!isInitial) {
          this.updateForm.pay_account = ''
        }
        
        console.log('当前渠道:', channel)
        console.log('可选账号:', this.payAccountOptions)
      } else {
        this.payAccountOptions = []
        console.warn('未找到对应的付款渠道')
      }
    },

    // 显示修改对话框
    handleUpdate(row) {
      // 构造修改表单数据
      this.updateForm = {
        id: row.id,
        application_id: row.application_id,
        payment_type: row.payment_type || '', // 付款类型
        payment_amount: row.payment_amount,
        payment_time: row.payment_time || new Date().toISOString().slice(0, 19).replace('T', ' '),
        payment_image: row.payment_image || '11111',
        payment_person: row.payment_person || '',
        pay_channel: row.pay_channel || '',
        pay_account: row.pay_account || '',
        pay_remark: row.pay_remark || '',
        receiver_method: row.receiver_method || '',
        receiver_channel: row.receiver_channel || '',
        receiver_name: row.receiver_name || '',
        receiver_account: row.receiver_account || '',
        receiver_bank: row.receiver_bank || '',
        receiver_bank_code: row.receiver_bank_code || '',
        receiver_remark: row.receiver_remark || '',
        fileList: []
      }

      // 如果有付款渠道，则获取对应的付款账号
      // 确保先加载付款渠道数据
      Promise.resolve().then(() => {
        if (this.updateForm.pay_channel && this.channels.length > 0) {
          this.getPayAccountDict(true) // 传入 true 表示是初始加载
        }
      })

      // 打印日志便于调试
      console.log('修改表单数据:', this.updateForm)
      console.log('原始行数据:', row)

      this.updateDialogVisible = true
    },

    // 取消修改
    cancelUpdate() {
      this.updateDialogVisible = false
      this.resetForm('updateForm')
    },

    // 提交修改
    async submitUpdate() {
      this.$refs.updateForm.validate(async valid => {
        if (valid) {
          try {
            // 构造请求参数，严格按照API文档格式
            const params = {
              id: this.updateForm.id,
              application_id: this.updateForm.application_id,
              payment_type: this.updateForm.payment_type,
              payment_amount: this.updateForm.payment_amount,
              payment_time: this.updateForm.payment_time,
              payment_image: this.updateForm.payment_image,
              payment_person: this.updateForm.payment_person,
              pay_channel: this.updateForm.pay_channel,
              pay_account: this.updateForm.pay_account,
              pay_remark: this.updateForm.pay_remark,
              receiver_method: this.updateForm.receiver_method,
              receiver_channel: this.updateForm.receiver_channel,
              receiver_name: this.updateForm.receiver_name,
              receiver_account: this.updateForm.receiver_account,
              receiver_bank: this.updateForm.receiver_bank,
              receiver_bank_code: this.updateForm.receiver_bank_code,
              receiver_remark: this.updateForm.receiver_remark
            }

            // 打印请求参数
            console.log('提交的参数:', params)

            const response = await request({
              url: '/api/v1/purchasing-order/payment/record/save',
              method: 'post',
              data: params
            })
            
            if (response.status === 1) {
              this.$message.success('修改成功')
              this.updateDialogVisible = false
              this.getList() // 刷新列表
            } 
          } catch (error) {
            console.error('修改付款记录失败:', error)
            this.$message.error('只有已审批通过的付款申请才能录入/修改付款记录')
          }
        }
      })
    },

    // 删除记录
    handleDelete(row) {
      this.$confirm('确认要删除该付款记录吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await request({
            url: '/api/v1/purchasing-order/payment/delete',
            method: 'post',
            data: { id: row.id }
          })
          
          if (response.status === 1) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(response.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除付款记录失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

    // 处理下拉菜单命令
    handleCommand(command, row) {
      switch (command) {
        case 'update':
          this.handleUpdate(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        default:
          break
      }
    },

    // 上传前验证
    beforeUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isJPGOrPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    
    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      if (response.status === 1) {
        this.updateForm.payment_image = response.data.SavePath
       this.$message.success('上传成功')
      } else {
        this.$message.error(response.msg || '上传失败')
        this.updateForm.fileList = this.updateForm.fileList.filter(f => f.uid !== file.uid)
      }
    },
    
    // 上传失败回调
    handleUploadError(err) {
      console.error('上传失败:', err)
      this.$message.error('上传失败')
    },
    
    // 超出限制回调
    handleExceed() {
      this.$message.warning('最多只能上传1张图片')
    },
    
    // 预览图片
    handlePreview(file) {
      if (file.url) {
        window.open(file.url)
      }
    },
    
    // 移除图片
    handleRemove(file, fileList) {
      this.updateForm.fileList = fileList
      this.updateForm.payment_image = '' // 清空付款凭证路径
    },
  }
}
</script>

<style scoped>
.payment-records {
  padding: 20px;
}

.filter-container {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.el-table .cell {
  white-space: nowrap;
}

.dialog-footer {
  text-align: right;
}

.el-input-number {
  width: 100%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-dropdown-menu__item [class^="el-icon-"] {
  margin-right: 5px;
}

.dropdown-danger {
  color: #F56C6C;
}

.dropdown-danger:hover {
  color: #F56C6C;
  background-color: #fef0f0;
}

.upload-container {
  .el-upload {
    width: 100%;
  }
  .el-upload-list {
    margin-top: 10px;
  }
  .el-upload__tip {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
  }
}
</style>
